import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Header } from 'semantic-ui-react'
import { Title } from '../components'
import { signIn } from '../../common/auth/actions'
import { SignInForm } from '../forms'

import './SignIn.scss'

const getQuery = (search) => {
  const query = {}
  const parts = (search[0] === '?' ? search.substr(1) : search).split('&')
  parts.forEach(part => {
    const item = part.split('=')
    query[decodeURIComponent(item[0])] = decodeURIComponent(item[1] || '')
  })
  return query
}

const SignInPage = (props) => {
  const { location, viewer, signIn } = props
  const statePathname = location.state && location.state.from && location.state.from.pathname
  const query = getQuery(location.search)
  const queryPathname = query && query.r
  if (viewer) return <Redirect to={statePathname || queryPathname || '/'} />
  return (
    <main className="sign-in">
      <Title message="Přihlášení" />
      <div className="container">
        <img src="/images/eda.svg" alt="eDA" className="logo" />
        <Header as="h1">
          Přihlaste se
        </Header>
        <SignInForm signIn={signIn} />
      </div>
    </main>
  )
}

SignInPage.propTypes = {
  location: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object,
  signIn: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  viewer: state.users.viewer,
}), { signIn })(SignInPage)



// WEBPACK FOOTER //
// ./src/browser/pages/SignIn.js